import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./authentication/reducer";
import complaintsReducer from "./complaints/reducer";
import workforceReducer from "./workforce/reducer";
import locationsReducer from "./locations/reducer";
import proceduresReducer from "./procedures/reducer";
import procedureHistoryReducer from "./proceduresHistory/reducer";
import profileReducer from "./profile/reducer";
import sensorsReducer from "./sensors/reducer";
import statusReducer from "./status/reducer";
import surveillanceReducer from "./surveillance/reducer";
import tableReducer from "./table/reducer";
import tracksReducer from "./track/reducer";
import reportsReducer from "./reports/reducer";
import notificationsReducer from "./notifications/reducer";
import supportReducer from "./support/reducer";

const authPersistConfig = {
  key: "auth",
  storage: storage,
  blacklist: ["loading", "credentials"]
};

const profilePersistConfig = {
  key: "profile",
  storage: storage,
  blacklist: ["loading"]
};

const statusPersistConfig = {
  key: "status",
  storage: storage,
  blacklist: ["code", "message"]
};

const complaintsPersistConfig = {
  key: "complaints",
  storage: storage,
  blacklist: ["loading", "data", "summaryData"]
};

const tracksPersistConfig = {
  key: "tracks",
  storage: storage,
  blacklist: ["loading", "data"]
};

const proceduresPersistConfig = {
  key: "procedures",
  storage: storage,
  blacklist: ["loading", "data"]
};

const reportsPersistConfig = {
  key: "reports",
  storage: storage,
  blacklist: ["loading", "data"]
};

const procedureHistoryPersistConfig = {
  key: "procedureHistory",
  storage: storage,
  blacklist: ["loading", "data"]
};

const workforcePersistConfig = {
  key: "workforce",
  storage: storage,
  blacklist: ["loading", "data", "captureSummary", "results"]
};

const locationsPersistConfig = {
  key: "locations",
  storage: storage,
  blacklist: ["loading", "data", "results"]
};

const sensorsPersistConfig = {
  key: "sensors",
  storage: storage,
  blacklist: ["loading", "data"]
};

const surveillancePersistConfig = {
  key: "surveillance",
  storage: storage,
  blacklist: ["loading", "reference", "captures", "pictureApprovalLoading"]
};
const notificationsPersistConfig = {
  key: "notifications",
  storage: storage,
  blacklist: ["loading"]
};

// Support tickets are always live-refetched from Plane, never worth
// persisting.
const supportPersistConfig = {
  key: "support",
  storage: storage,
  blacklist: ["submitting", "requests", "comments", "closingWorkItemId", "reopeningWorkItemId"]
};

//adding this because today date is persisting
const tablePersistConfig = {
  key: "table",
  storage: storage,
  blacklist: [
    "loading",
    "locations",
    "complaints",
    "procedures",
    "procedureHistory",
    "workforce",
    "tracks",
    "reports"
  ]
};

const rootPersistConfig = {
  key: "root",
  storage: storage,
  blacklist: [
    "auth",
    "complaints",
    "tracks",
    "locations",
    "profile",
    "status",
    "procedures",
    "procedureHistory",
    "workforce",
    "sensors",
    "surveillance",
    "table",
    "support",
    "reports"
  ]
};

//root reducer
const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  complaints: persistReducer(complaintsPersistConfig, complaintsReducer),
  tracks: persistReducer(tracksPersistConfig, tracksReducer),
  locations: persistReducer(locationsPersistConfig, locationsReducer),
  profile: persistReducer(profilePersistConfig, profileReducer),
  status: persistReducer(statusPersistConfig, statusReducer),
  procedures: persistReducer(proceduresPersistConfig, proceduresReducer),
  procedureHistory: persistReducer(
    procedureHistoryPersistConfig,
    procedureHistoryReducer
  ),
  workforce: persistReducer(workforcePersistConfig, workforceReducer),
  reports: persistReducer(reportsPersistConfig, reportsReducer),
  sensors: persistReducer(sensorsPersistConfig, sensorsReducer),
  surveillance: persistReducer(surveillancePersistConfig, surveillanceReducer),
  table: persistReducer(tablePersistConfig, tableReducer),
  notifications: persistReducer(
    notificationsPersistConfig,
    notificationsReducer
  ),
  support: persistReducer(supportPersistConfig, supportReducer)
});

export const persistedReducer = persistReducer(rootPersistConfig, rootReducer);
